import React, { useState } from "react";
import { Formik, useField } from "formik";
import * as yup from "yup";
import {
  Box,
  Button,
  CircularProgress,
  TextField,
  Card,
  Typography,
  MenuItem,
  FormHelperText,
  InputLabel,
  FormControl,
  Select,
  IconButton, InputAdornment
} from "@mui/material";
import { styled } from "@mui/material/styles";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import swal from "sweetalert";
import Swal from "sweetalert2";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import imageCompression from "browser-image-compression";
import { PDFDocument } from "pdf-lib";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useAuth } from "../../../AuthProvider";
import UploadFileIcon from '@mui/icons-material/UploadFile';
import * as XLSX from "xlsx";

// Define styled components
const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

const FacebookCircularProgress = styled(CircularProgress)({
  color: "#3b5998",
});

const states = [
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chhattisgarh",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
  "Other",
];

const EmployeeRegForm = () => {
  const [currentTab, setCurrentTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { userId, oId, token, pId, feature, plan } = useAuth(); // Access userId from AuthContext
  const baseUrl = process.env.REACT_APP_API_BASE_URL;

  const [selectedUsers, setSelectedUsers] = useState("");
  const [excelloading, setExcelLoading] = useState(false);
  const [excelData, setExcelData] = useState([]);
  const [fileName, setFileName] = useState("");

  // Validation schema using yup
  const validationSchemaTab0 = yup.object().shape({
    // Basic Details
    // prefix: yup.string().required("Prefix is required"),

    // maritalStatus: yup.string().required("maritalStatus is required"),

    firstName: yup
      .string()
      .required("First Name is required")
      .matches(/^[a-zA-Z\s]+$/, "First Name can only contain letters"),
    lastName: yup
      .string()
      .required("Last Name is required")
      .matches(/^[a-zA-Z\s]+$/, "Last Name can only contain letters"),
    emailId: yup
      .string()
      .email("Invalid email format"),
    // .required("Email is required"),
    contactNumber1: yup
      .string()
      .required("Contact Number is required")
      .matches(/^\d+$/, "Contact Number can only contain numbers")
      .matches(/^[0-9]{10}$/, "Contact Number must be exactly 10 digits"),

    // gender: yup.string().required("Gender is required"),

    // dateofBirth: yup
    //   .date()
    //   .required("Date of Birth is required")
    //   .max(new Date(), "Date of Birth cannot be in the future"),

    // nationality: yup.string().required("Nationality is required"),

    workEmail: yup
      .string()
      .email("Invalid email format"),
    // .required("Work Email is required"),
    // joiningDate: yup
    //   .date()
    //   .required("Joining Date is required")
    //   .max(new Date(), "Joining Date cannot be in the future"),
    //  joiningDate: yup
    //       .date()
    //       .typeError("Invalid date format") // Ensures correct date input
    //       .required("Joining Date is required"), // No max restriction, allows future dates

    city: yup
      .string()
      .required("City is required")
      .matches(/^[a-zA-Z\s]+$/, "City can only contain letters"),

    state: yup.string().required("State is required"),
    role: yup.string().required("Role is required"),

    // bloodGroup: yup
    //   .string()
    //   .oneOf(
    //     ["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-", ""],
    //     "Invalid Blood Group"
    //   )
    //   .required("Blood Group is required"),
  });

  const validationSchemaTab1 = yup.object().shape({
    panNumber: yup
      .string()
      // .required("PAN Number is required")
      .matches(
        /^(?=(.*[A-Z]){6})(?=(.*[0-9]){4})[A-Z0-9]{10}$/,
        "PAN Number must have exactly 6 capital letters and 4 digits in any order"
      ),

    // aadharNumber: yup
    //   .string()
    //   .required("Aadhar Number is required")
    //   .matches(/^[0-9]{12}$/, "Aadhar Number must be exactly 12 digits"),

    // fatherName: yup
    //   .string()
    //   .required("Father Name is required")
    //   .matches(/^[A-Za-z\s]+$/, "Father Name can only contain letters")
    //   .max(100, "Father Name cannot exceed 100 characters"),

    // motherName: yup
    //   .string()
    //   .required("Mother Name is required")
    //   .matches(/^[A-Za-z\s]+$/, "Mother Name can only contain letters")
    //   .max(100, "Mother Name cannot exceed 100 characters"),

    // contactNumber2: yup
    //       .string()
    //       .required("Emergency Contact Number is required")
    //       .matches(/^\d+$/, "Emergency Contact Number can only contain numbers")
    //       .matches(/^[0-9]{10}$/, "Emergency Contact Number must be exactly 10 digits"),

    // maritalStatus: yup
    //   .string()
    //   .oneOf(
    //     ["UnMarried", "Married", "Divorced", "Widowed", "Other",],
    //     "Invalid marital status"
    //   )
    //   .required("Marital status is required"),
  });
  const validationSchemaTab2 = yup.object().shape({
    // higherQualification: yup
    //   .string()
    //   .required("Higher Qualification is required")
    //   .matches(
    //     /^[A-Za-z.\s]+$/,
    //     "Higher Qualification can only contain letters, spaces, and a period (.)"
    //   )
    //   .max(50, "Qualification can't be longer than 50 characters"),
    currentCtc: yup
      .number()
      .typeError("CTC must be a number")
      .required("Current CTC is required")
      .positive("CTC must be a positive number")
      .max(10000000, "CTC cannot exceed 10 million"), // Example max value

    // previousSchoolName: yup
    //   .string()
    //   .required("previousSchoolName is required")
    //   .matches(/^[A-Za-z\s]+$/, "previousSchoolName can only contain letters"),

    department: yup
      .string()
      .required("department is required")
      .matches(/^[A-Za-z\s]+$/, "department can only contain letters"),

    // designation: yup
    //   .string()
    //   .required("designation is required")
    //   .matches(/^[A-Za-z\s]+$/, "designation can only contain letters"),

    // previousExperience: yup
    //   .number()
    //   .typeError("Previous Experience must be a number")
    //   .required("Previous Experience is required")
    //   .min(0, "Previous Experience cannot be negative") // Allows 0 and positive numbers
    //   .max(99, "Previous Experience cannot exceed 2 digits"), // Ensures up to 2 digits
  });
  const validationSchemaTab4 = yup.object().shape({
    bankName: yup
      .string()
      // .required("Bank Name is required")
      .matches(/^[A-Za-z\s]+$/, "Bank Name can only contain letters")
      .max(100, "Bank Name cannot exceed 100 characters"),

    bankAccount: yup
      .string()
      // .required("Bank Account Number is required")
      .matches(
        /^\d{9,18}$/,
        "Bank Account Number must be between 9 and 18 digits"
      ),

    ifscCode: yup
      .string()
      // .required("IFSC Code is required")
      .matches(
        /^[A-Z]{4}0[A-Z0-9]{6}$/,
        "IFSC Code must be in capital letters and numbers"
      ),

    bankBranch: yup
      .string()
      // .required("Bank Branch is required")
      .matches(/^[A-Za-z\s]+$/, "Bank Branch can only contain letters")
      .max(100, "Bank Branch cannot exceed 100 characters"),
  });
  const validationSchemaTab5 = yup.object().shape({
    profilePic: yup
      .mixed()
      // .required("Profile picture is required")
      .test("fileSize", "File size should be less than 1MB", (value) => {
        return value && value.size <= 1024 * 1024; // 1MB in bytes
      })
      .test(
        "fileFormat",
        "Unsupported file format. Only JPG, JPEG, and PNG are allowed",
        (value) => {
          return (
            value &&
            ["image/jpeg", "image/jpg", "image/png"].includes(value.type)
          );
        }
      ),
  });

  const getValidationSchema = () => {
    switch (currentTab) {
      case 0:
        return validationSchemaTab0;
      case 1:
        return validationSchemaTab1;
      case 2:
        return validationSchemaTab2;
      case 4:
        return validationSchemaTab4;
      case 5:
        return validationSchemaTab5;
      // Add cases for other tabs if needed
      default:
        return validationSchemaTab0; // Default schema
    }
  };

  //  new handle submit code
  // const handleSubmit = async (values) => {
  //   // Show confirmation dialog
  //   const result = await Swal.fire({
  //     title: "Add Employee",
  //     text: "Are you sure you want to add new employee?",
  //     icon: "question",
  //     showCancelButton: true,
  //     confirmButtonText: "Confirm",
  //     cancelButtonText: "Cancel",
  //   });

  //   if (result.isConfirmed) {
  //     setLoading(true);
  //     try {
  //       //
  //       const sanitizedValues = { ...values };
  //       Object.keys(sanitizedValues).forEach((key) => {
  //         if (sanitizedValues[key] === "" || sanitizedValues[key] === "null") {
  //           sanitizedValues[key] = null;
  //         }
  //       });

  //       const formData = new FormData();

  //       // Function to compress files
  //       const compressFile = async (file) => {
  //         if (!file) return file;

  //         if (file.type.startsWith("image/")) {
  //           // Compress image file
  //           const options = { maxSizeMB: 1, maxWidthOrHeight: 1024 };
  //           return await imageCompression(file, options);
  //         } else if (file.type === "application/pdf") {
  //           // Compress PDF file
  //           const pdfDoc = await PDFDocument.load(await file.arrayBuffer());
  //           const compressedPdf = await pdfDoc.save();
  //           return new Blob([compressedPdf], { type: "application/pdf" });
  //         }
  //         return file;
  //       };

  //       // Function to handle and append files
  //       const handleFile = async (key, file) => {
  //         const compressedFile = await compressFile(file);
  //         formData.append(key, compressedFile);
  //       };

  //       // Append files and other values to FormData
  //       await Promise.all(
  //         Object.keys(sanitizedValues).map(async (key) => {
  //           if (sanitizedValues[key] && sanitizedValues[key] instanceof File) {
  //             await handleFile(key, sanitizedValues[key]);
  //           } else if (sanitizedValues[key] !== null) {
  //             formData.append(key, sanitizedValues[key]);
  //           }
  //         })
  //       );

  //       const apiEndpoint = `${baseUrl}/api/principal/saveEmployee/${pId}`;

  //       // Make the API call
  //       const response = await fetch(apiEndpoint, {
  //         method: "POST",
  //         body: formData,
  //       });

  //       if (response.ok) {
  //         const responseData = await response.json();
  //         Swal.fire({
  //           title: "Success",
  //           text: "Employee Added Successfully",
  //           icon: "success",
  //         });
  //       } else {
  //         const errorText = await response.text();
  //         console.error(
  //           "Error submitting the form:",
  //           response.statusText,
  //           errorText
  //         );
  //         Swal.fire({
  //           title: "Error",
  //           text: `${response.statusText} ${errorText}`,
  //           icon: "error",
  //         });
  //       }
  //     } catch (error) {
  //       console.error("Error submitting the form", error);
  //       Swal.fire({
  //         title: "Error",
  //         text: "An unexpected error occurred while submitting the form.",
  //         icon: "error",
  //       });
  //     } finally {
  //       setLoading(false);
  //     }
  //   }
  // };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) {
      setFileName("Upload Excel");
      return;
    }


    setFileName(file.name); // show filename
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheet = workbook.Sheets[workbook.SheetNames[0]];
      const parsedData = XLSX.utils.sheet_to_json(sheet);

      // Convert all string values to uppercase
      const upperCasedData = parsedData.map((row) => {
        const upperRow = {};
        Object.entries(row).forEach(([key, value]) => {
          upperRow[key] = typeof value === "string" ? value.toUpperCase() : value;
        });
        return upperRow;
      });

      setExcelData(parsedData);
    };
    reader.readAsArrayBuffer(file);
  };

  const handleExcelSubmit = async () => {
    if (excelData.length === 0) return alert("Please upload an Excel file first.");

    setExcelLoading(true);

    try {
      const UserId = userId || selectedUsers;
      const response = await fetch(`${baseUrl}/api/principal/bulk/register/${pId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(excelData),
      });

      if (response.ok) {
        toast.success("Excel data uploaded successfully!", {
          onClose: () => navigate("/Employee"),
        });

      } else {
        const error = await response.json();
        console.error("Upload failed:", error);
        toast.error("Upload failed.");
      }
    } catch (err) {
      console.error("Error submitting:", err);
      toast.error("Something went wrong.");
    }
    finally {
      setExcelLoading(false); // Stop loading
    }
  };



  const handleSubmit = async (values) => {
    // Show confirmation dialog
    const result = await Swal.fire({
      title: 'Add Employee',
      text: "Are you sure you want to add new employee?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    });

    if (result.isConfirmed) {
      setLoading(true);
      try {
        const sanitizedValues = { ...values };

        // Nullify empty or "null" string values
        Object.keys(sanitizedValues).forEach((key) => {
          if (sanitizedValues[key] === '' || sanitizedValues[key] === 'null') {
            sanitizedValues[key] = null;
          }
        });

        // ✅ Add +91 to contactNumber1 if not already present

        if (sanitizedValues.contactNumber1) {
          let c = sanitizedValues.contactNumber1.toString().replace(/\D/g, ''); // keep digits only

          if (c.length === 10) {
            // It's a normal 10-digit number, add country code
            sanitizedValues.contactNumber1 = `91${c}`;
          } else if (c.length === 12 && c.startsWith("91")) {
            // Already in +91 format (country code), keep as is
            sanitizedValues.contactNumber1 = c;
          } else {
            // Invalid number (e.g. 11 digits, wrongly formatted), handle as needed
            sanitizedValues.contactNumber1 = null;
          }
        }

        const formData = new FormData();

        // Compress images or PDFs if needed
        // const compressFile = async (file) => {
        //   if (!file) return file;

        //   if (file.type.startsWith('image/')) {
        //     const options = { maxSizeMB: 1, maxWidthOrHeight: 1024 };
        //     return await imageCompression(file, options);
        //   } else if (file.type === 'application/pdf') {
        //     const pdfDoc = await PDFDocument.load(await file.arrayBuffer());
        //     const compressedPdf = await pdfDoc.save();
        //     return new Blob([compressedPdf], { type: 'application/pdf' });
        //   }
        //   return file;
        // };

        // // Append compressed files or normal fields to FormData
        // const handleFile = async (key, file) => {
        //   const compressedFile = await compressFile(file);
        //   formData.append(key, compressedFile);
        // };

        const compressFile = async (file) => {
          if (!file) return file;

          if (file.type.startsWith('image/')) {
            const options = { maxSizeMB: 1, maxWidthOrHeight: 1024, useWebWorker: true };
            const compressedBlob = await imageCompression(file, options);
            // Keep original name & extension
            return new File([compressedBlob], file.name, { type: file.type });
          }
          else if (file.type === 'application/pdf') {
            const pdfDoc = await PDFDocument.load(await file.arrayBuffer());
            const compressedPdf = await pdfDoc.save();
            return new File([compressedPdf], file.name, { type: 'application/pdf' });
          }
          else {
            // Unsupported format — send original file
            return file;
          }
        };

        const handleFile = async (key, file) => {
          const compressedFile = await compressFile(file);
          formData.append(key, compressedFile, compressedFile.name);
        };


        await Promise.all(
          Object.keys(sanitizedValues).map(async (key) => {
            if (sanitizedValues[key] && sanitizedValues[key] instanceof File) {
              await handleFile(key, sanitizedValues[key]);
            } else if (sanitizedValues[key] !== null) {
              formData.append(key, sanitizedValues[key]);
            }
          })
        );

        const response = await fetch(`${baseUrl}/api/principal/saveEmployee/${pId}`, {
          method: 'POST',
          body: formData,
        });

        const responseData = await response.json(); // ✅ Parse response JSON only once

        if (response.ok) {
          // const responseData = await response.json();
          // Show success toast message
          toast.success('Employee Added Successfully', {
            position: "top-right",
            autoClose: 1000,
          });

          // Wait for 2 seconds before navigating
          setTimeout(() => {
            navigate(-1);
          }, 1080);
        } else {
          const errorMessage = responseData?.error_message || "Error submitting the form.";
          console.error("Error submitting the form:", errorMessage);

          toast.error(errorMessage, {
            position: "top-right",
            autoClose: 2000,
          });

        }
      } catch (error) {
        console.error('Error submitting the form', error);
        // Show error toast message
        toast.error('An unexpected error occurred while submitting the form.', {
          position: "top-right",
          autoClose: 1000,
        });
      } finally {
        setLoading(false);
      }
    }
  };


  // Initial form values
  const initialValues = {
    //Basic
    prefix: "",
    firstName: "",
    lastName: "",
    emailId: "",
    contactNumber1: "",
    gender: "",
    dateofBirth: "",
    nationality: "",
    workEmail: "",
    joiningDate: "",
    hno: "",
    city: "",
    state: "",
    bloodGroup: "",
    role: "",

    //Personal Deatils
    panNumber: "",
    aadharNumber: "",
    passportNo: "",
    contactNumber2: "",
    uan: "",

    //Family Details
    fatherName: "",
    motherName: "",
    maritalStatus: "",

    //Professional Summary
    previousSchoolName: "",
    previousExperience: "",
    department: "",
    designation: "",
    currentCtc: "",
    higherQualification: "",

    bonus: 0,
    otherEarnings: 0,
    workBasisPay: 0,
    overTime: 0,
    incentive: 0,
    tax: 0,
    pf: 0,
    loanRepayment: 0,
    earlyLeavingFine: 0,
    lateComingFine: 0,
    otherDeductions: 0,
    hra: 0,
    dra: 0,
    petrolAllowance: 0,
    foodAllowance: 0,
    basicSalary: 0,

    //Bank details
    bankName: "",
    bankAccount: "",
    ifscCode: "",
    bankBranch: "",

    //Documents
    profilePic: null,
    // document1: null,
    // document2: null,
    // document3: null,
  };

  const genderOptions = [
    { value: "male", label: "Male" },
    { value: "female", label: "Female" },
    { value: "other", label: "Other" },
  ];

  const prefixOptions = [
    { value: "Mr.", label: "Mr." },
    { value: "Mrs.", label: "Mrs." },
    { value: "Miss.", label: "Miss." },
    { value: "Ms.", label: "Ms." },
    { value: "Mx.", label: "Mx." },
  ];










  const allFeatureRoles = [
    { value: "TEACHER", label: "TEACHER" },
    { value: "DRIVER", label: "DRIVER" },
    { value: "ATTENDER", label: "ATTENDER" },
    // { value: "MAINTEN_STAFF", label: "MAINTENANCE STAFF" },
    { value: "ADMISSION_FEE", label: "ADMISSION" },
    { value: "EXAMINATION_CELL", label: "EXAMINATION" },
    { value: "SCHEDULE_MEETING", label: "SCHEDULE MEETING" },
    { value: "HRBP", label: "HUMAN RESOURCE" },
    { value: "TRANSPORT", label: "TRANSPORT" },
    { value: "STORE_DEPARTMENT", label: "STORE" },
  ];



  const roleMapByFeature = {
    LITE: [
      "TEACHER",
      // 'MAINTEN_STAFF',
      "ADMISSION_FEE",
      "EXAMINATION_CELL",
      "SCHEDULE_MEETING",
      "HRBP",
    ],
    CORE: [
      "TEACHER",
      "DRIVER",
      "ATTENDER",
      // 'MAINTEN_STAFF',
      "ADMISSION_FEE",
      "EXAMINATION_CELL",
      "SCHEDULE_MEETING",
      "HRBP",
      "TRANSPORT",
      "STORE_DEPARTMENT",
    ],
    ULTRA: [
      "TEACHER",
      "DRIVER",
      "ATTENDER",
      // 'MAINTEN_STAFF',
      "ADMISSION_FEE",
      "EXAMINATION_CELL",
      "SCHEDULE_MEETING",
      "HRBP",
      "TRANSPORT",
      "STORE_DEPARTMENT",
    ],
  };

  const visibleFeatureRoles = allFeatureRoles.filter((role) =>
    roleMapByFeature[feature]?.includes(role.value)
  );



  return (
    <Box marginTop={9}>
      <Formik
        initialValues={initialValues}
        validationSchema={getValidationSchema()}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          validateForm,
          setFieldValue,
          setTouched,
        }) => (
          <form
            onSubmit={(e) => {
              e.preventDefault(); // Prevent the default form submission behavior
              handleSubmit(values); // Call the handleSubmit function with form values
            }}
          >
            <Box display="flex" flexDirection="column" alignItems="center">
              <Card
                sx={{
                  padding: 2,
                  backgroundColor: "#fff",
                  width: "96%",
                  height: "60%",
                }}
              >
                {/* <Typography variant="h3" sx={{textAlign:'center',fontWeight:'bold'}}>Staff Registrations</Typography> */}
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  sx={{ marginBottom: 2 }}
                >
                  {/* <IconButton
                    onClick={() => navigate(-1)}
                    sx={{ color: "#2e2a54" }}
                  >
                    <KeyboardBackspaceIcon fontSize="medium" />
                  </IconButton> */}
                  <Typography
                    variant="h4"
                    component="h3"
                    sx={{ fontWeight: "bold" }}
                  >
                    Employee Registration
                  </Typography>
                </Box>

                {currentTab === 0 && (
                  <Box>
                    <Box display="flex" justifyContent="space-between" alignItems="center" marginBottom={2}>
                      {/* Left Side: Back Button + Title */}
                      <Box display="flex" alignItems="center">
                        <IconButton onClick={() => navigate(-1)} sx={{ color: "#2e2a54" }}>
                          <KeyboardBackspaceIcon fontSize="medium" />
                        </IconButton>
                        <Typography variant="h6" fontSize={20} sx={{ fontWeight: "bold" }}>
                          Basic Details
                        </Typography>
                      </Box>

                      {/* Right Side: Upload + Submit Buttons */}
                      {/* <Box display="flex" alignItems="center" gap={2}>
    <Button
      variant="contained"
      component="label"
      startIcon={<UploadFileIcon />}
      sx={{ textTransform: "none", backgroundColor: "#3C3972" }}
    >
      {fileName ? fileName : "Upload Excel"}
      <input type="file" accept=".xlsx, .xls" hidden onChange={handleFileUpload} />
    </Button>

    <Button
      variant="outlined"
      color="primary"
      onClick={handleExcelSubmit}
      disabled={excelData.length === 0}
    >
      {excelloading ? <CircularProgress size={20} color="inherit" /> : "Submit"}
    </Button>
  </Box> */}
                    </Box>

                    <Box
                      display="grid"
                      gap="15px"
                      gridTemplateColumns="repeat(3, minmax(0, 1fr))"
                    >
                      <FormControl
                        fullWidth
                        error={touched.prefix && !!errors.prefix}
                      >
                        <InputLabel htmlFor="prefix">Prefix</InputLabel>
                        <Select
                          id="prefix"
                          name="prefix"
                          value={values.prefix}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          label="Prefix"
                          inputProps={{
                            id: "prefix",
                          }}
                        >
                          {prefixOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>
                          {touched.prefix && errors.prefix}
                        </FormHelperText>
                      </FormControl>

                      <StyledTextField
                        fullWidth
                        type="text"
                        label="First Name*"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.firstName}
                        name="firstName"
                        autoComplete="off"
                        error={!!touched.firstName && !!errors.firstName}
                        helperText={touched.firstName && errors.firstName}
                      />

                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Last Name*"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.lastName}
                        name="lastName"
                        autoComplete="off"
                        error={!!touched.lastName && !!errors.lastName}
                        helperText={touched.lastName && errors.lastName}
                      />
                      <StyledTextField
                        fullWidth
                        type="email"
                        label="Email"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.emailId}
                        name="emailId"
                        autoComplete="off"
                        error={!!touched.emailId && !!errors.emailId}
                        helperText={touched.emailId && errors.emailId}
                      />
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Contact Number*"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          // Allow only up to 10 digits
                          const value = e.target.value.slice(0, 10);
                          handleChange({
                            target: {
                              name: e.target.name,
                              value,
                            },
                          });
                        }}
                        value={values.contactNumber1}
                        name="contactNumber1"
                        autoComplete="off"
                        error={!!touched.contactNumber1 && !!errors.contactNumber1}
                        helperText={touched.contactNumber1 && errors.contactNumber1}
                        InputProps={{
                          startAdornment: <InputAdornment position="start">+91</InputAdornment>,
                        }}
                      />


                      <StyledTextField
                        fullWidth
                        type="date"
                        label="Date of Birth"
                        InputLabelProps={{ shrink: true }}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.dateofBirth}
                        name="dateofBirth"
                        autoComplete="off"
                        error={!!touched.dateofBirth && !!errors.dateofBirth}
                        helperText={touched.dateofBirth && errors.dateofBirth}
                      />
                      <StyledTextField
                        fullWidth
                        type="email"
                        label="Work Email"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.workEmail}
                        name="workEmail"
                        autoComplete="off"
                        error={!!touched.workEmail && !!errors.workEmail}
                        helperText={touched.workEmail && errors.workEmail}
                      />
                      <StyledTextField
                        fullWidth
                        type="date"
                        label="Joining Date"
                        InputLabelProps={{ shrink: true }}
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.joiningDate}
                        name="joiningDate"
                        autoComplete="off"
                        error={!!touched.joiningDate && !!errors.joiningDate}
                        helperText={touched.joiningDate && errors.joiningDate}
                      />
                      <StyledTextField
                        fullWidth
                        type="text"
                        label="House Number"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.hno}
                        name="hno"
                        autoComplete="off"
                        error={!!touched.hno && !!errors.hno}
                        helperText={touched.hno && errors.hno}
                      />
                      <StyledTextField
                        fullWidth
                        type="text"
                        label="City*"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          // Allow only letters (A–Z or a–z)
                          const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: lettersOnly,
                            },
                          });
                        }}
                        value={values.city}
                        name="city"
                        autoComplete="off"
                        error={!!touched.city && !!errors.city}
                        helperText={touched.city && errors.city}
                      />

                      {/* <StyledTextField
                        fullWidth
                        type="text"
                        label="State"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.state}
                        name="state"
                        autoComplete="off"
                        error={!!touched.state && !!errors.state}
                        helperText={touched.state && errors.state}
                      /> */}
                      <FormControl fullWidth>
                        <InputLabel>State*</InputLabel>
                        <Select
                          label="State*"
                          value={values.state || ""}
                          onChange={handleChange}
                          name="state"
                          onBlur={handleBlur}
                          error={!!touched.state && !!errors.state}
                        >
                          {states.map((state) => (
                            <MenuItem key={state} value={state}>
                              {state}
                            </MenuItem>
                          ))}
                        </Select>
                        {touched.state && errors.state && (
                          <Typography color="error" variant="body2">
                            {errors.state}
                          </Typography>
                        )}
                      </FormControl>

                      <FormControl fullWidth>
                        <InputLabel>Blood Group</InputLabel>
                        <Select
                          label="Blood Group"
                          value={values.bloodGroup}
                          onChange={handleChange}
                          name="bloodGroup"
                          onBlur={handleBlur}
                          error={!!touched.bloodGroup && !!errors.bloodGroup}
                        >
                          <MenuItem value="A+">A+</MenuItem>
                          <MenuItem value="A-">A-</MenuItem>
                          <MenuItem value="B+">B+</MenuItem>
                          <MenuItem value="B-">B-</MenuItem>
                          <MenuItem value="O+">O+</MenuItem>
                          <MenuItem value="O-">O-</MenuItem>
                          <MenuItem value="AB+">AB+</MenuItem>
                          <MenuItem value="AB-">AB-</MenuItem>
                          <MenuItem value="">None</MenuItem>{" "}
                          {/* Fixed the duplicate value */}
                        </Select>
                        {touched.bloodGroup && errors.bloodGroup && (
                          <Typography color="error" variant="body2">
                            {errors.bloodGroup}
                          </Typography>
                        )}
                      </FormControl>

                      <FormControl fullWidth>
                        <InputLabel>Nationality</InputLabel>
                        <Select
                          label="Nationality"
                          value={values.nationality}
                          onChange={handleChange}
                          name="nationality"
                          onBlur={handleBlur}
                          error={!!touched.nationality && !!errors.nationality}
                        >
                          <MenuItem value="Indian">Indian</MenuItem>
                          <MenuItem value="Other">Other</MenuItem>
                        </Select>
                        {touched.nationality && errors.nationality && (
                          <Typography color="error" variant="body2">
                            {errors.nationality}
                          </Typography>
                        )}
                      </FormControl>

                      <FormControl
                        fullWidth
                        error={touched.gender && !!errors.gender}
                      >
                        <InputLabel htmlFor="gender">Gender</InputLabel>
                        <Select
                          id="gender"
                          name="gender"
                          value={values.gender}
                          onBlur={handleBlur}
                          onChange={handleChange}
                          label="Gender"
                          inputProps={{
                            id: "gender",
                          }}
                        >
                          {genderOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                              {option.label}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>
                          {touched.gender && errors.gender}
                        </FormHelperText>
                      </FormControl>
                      {/* newly added code */}
                      {/* <FormControl fullWidth>
            <InputLabel>Select Role</InputLabel>
            <Select
              label="Select Role"
              name="role"
              value={values.role}
              onBlur={handleBlur}
              onChange={(e) => setFieldValue("role", e.target.value)}
              error={!!touched.role && !!errors.role}
            >
              <MenuItem value="TEACHER">TEACHER</MenuItem>
              <MenuItem value="ADMISSION_FEE">ADMISSION</MenuItem>
              <MenuItem value="EXAMINATION_CELL">EXAMINATION</MenuItem>
              <MenuItem value="TRANSPORT">TRANSPORT</MenuItem>
              {["CORE", "ULTRA"].includes(feature) && (
                <>
                  <MenuItem value="STORE_DEPARTMENT">STORE</MenuItem>
                  <MenuItem value="DRIVER">DRIVER</MenuItem>
                  <MenuItem value="ATTENDER">ATTENDER</MenuItem>
                </>
              )}
            </Select>
            {touched.role && errors.role && (
              <Typography color="error">{errors.role}</Typography>
            )}
          </FormControl> */}
                      <FormControl fullWidth>
                        <InputLabel>Select Role*</InputLabel>
                        <Select
                          label="Select Role*"
                          name="role"
                          value={values.role}
                          onChange={(e) => setFieldValue("role", e.target.value)}
                          onBlur={handleBlur}
                          error={!!touched.role && !!errors.role}
                        >
                          {visibleFeatureRoles.map((role) => (
                            <MenuItem key={role.value} value={role.value}>
                              {role.label}
                            </MenuItem>
                          ))}
                        </Select>

                        {touched.role && errors.role && (
                          <Typography color="error">{errors.role}</Typography>
                        )}
                      </FormControl>




                    </Box>
                    <Box display="flex" justifyContent="flex-end" marginTop={3}>
                      <Button
                        variant="contained"
                        style={{ width: "100px", backgroundColor: "#3C3972" }}
                        onClick={async () => {
                          // Set all fields as touched to trigger error messages
                          setTouched({
                            prefix: true,
                            firstName: true,
                            lastName: true,
                            emailId: true,
                            contactNumber1: true,
                            gender: true,
                            dateofBirth: true,
                            nationality: true,
                            workEmail: true,
                            joiningDate: true,
                            city: true,
                            state: true,
                            role: true,
                            bloodGroup: true,
                          });
                          const errors = await validateForm();
                          if (!Object.keys(errors).length) {
                            setCurrentTab(1);
                          }
                        }}
                      >
                        Next
                      </Button>
                    </Box>
                  </Box>
                )}

                {currentTab === 1 && (
                  <Box>
                    <Typography
                      variant="h6"
                      fontSize={20}
                      sx={{ fontWeight: "bold" }}
                      marginBottom={2}
                    >
                      Personal Details
                    </Typography>

                    <Box
                      display="grid"
                      gap="15px"
                      gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                    >
                      <StyledTextField
                        fullWidth
                        type="text"
                        label="PAN Number"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          // Convert to uppercase
                          let value = e.target.value.toUpperCase();

                          // Allow only pattern of 5 letters, 4 digits, 1 letter (PAN format)
                          value = value.replace(/[^A-Z0-9]/g, ''); // Remove invalid chars
                          value = value.slice(0, 10); // Limit length to 10 characters

                          handleChange({
                            target: {
                              name: e.target.name,
                              value,
                            },
                          });
                        }}
                        value={values.panNumber}
                        name="panNumber"
                        autoComplete="off"
                        error={!!touched.panNumber && !!errors.panNumber}
                        helperText={touched.panNumber && errors.panNumber}
                      />

                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Aadhar Number"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          // Limit input to 12 digits
                          const value = e.target.value.slice(0, 12);
                          handleChange({
                            target: {
                              name: e.target.name,
                              value,
                            },
                          });
                        }}
                        value={values.aadharNumber}
                        name="aadharNumber"
                        autoComplete="off"
                        error={!!touched.aadharNumber && !!errors.aadharNumber}
                        helperText={touched.aadharNumber && errors.aadharNumber}
                      />

                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Passport No"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.passportNo}
                        name="passportNo"
                        autoComplete="off"
                        error={!!touched.passportNo && !!errors.passportNo}
                        helperText={touched.passportNo && errors.passportNo}
                      />
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="UAN No"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.uan}
                        name="uan"
                        autoComplete="off"
                        error={!!touched.uan && !!errors.uan}
                        helperText={touched.uan && errors.uan}
                      />
                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Father Name"
                        onBlur={handleBlur}
                        // onChange={handleChange}
                        onChange={(e) => {
                          const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.fatherName}
                        name="fatherName"
                        autoComplete="off"
                        error={!!touched.fatherName && !!errors.fatherName}
                        helperText={touched.fatherName && errors.fatherName}
                      />

                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Mother Name"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.motherName}
                        name="motherName"
                        autoComplete="off"
                        error={!!touched.motherName && !!errors.motherName}
                        helperText={touched.motherName && errors.motherName}
                      />

                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Emergency Contact No"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          // Allow only up to 10 digits
                          const value = e.target.value.slice(0, 10);
                          handleChange({
                            target: {
                              name: e.target.name,
                              value,
                            },
                          });
                        }}
                        value={values.contactNumber2}
                        name="contactNumber2"
                        autoComplete="off"
                        error={!!touched.contactNumber2 && !!errors.contactNumber2}
                        helperText={touched.contactNumber2 && errors.contactNumber2}
                      />


                      <FormControl
                        fullWidth
                        error={
                          !!touched.maritalStatus && !!errors.maritalStatus
                        }
                      >
                        <InputLabel>Marital Status</InputLabel>
                        <Select
                          label="Marital Status"
                          value={values.maritalStatus}
                          onChange={handleChange}
                          name="maritalStatus"
                          onBlur={handleBlur}
                        >
                          <MenuItem value="UnMarried">UnMarried</MenuItem>
                          <MenuItem value="Married">Married</MenuItem>
                          <MenuItem value="Divorced">Divorced</MenuItem>
                          <MenuItem value="Widowed">Widowed</MenuItem>
                          <MenuItem value="Other">Other</MenuItem>
                        </Select>
                        {touched.maritalStatus && errors.maritalStatus && (
                          <Typography color="error" variant="body2">
                            {errors.maritalStatus}
                          </Typography>
                        )}
                      </FormControl>
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      marginTop={3}
                    >
                      <Button
                        variant="contained"
                        style={{ width: "100px", backgroundColor: "#3C3972" }}
                        onClick={() => setCurrentTab(0)}
                      >
                        Previous
                      </Button>
                      <Button
                        variant="contained"
                        style={{ width: "100px", backgroundColor: "#3C3972" }}
                        onClick={async () => {
                          // Set all fields as touched to trigger error messages
                          setTouched({
                            panNumber: true,
                            aadharNumber: true,
                            fatherName: true,
                            motherName: true,
                            contactNumber2: true,
                            maritalStatus: true,
                            // Add other fields similarly
                          });
                          const errors = await validateForm();
                          if (!Object.keys(errors).length) {
                            setCurrentTab(2);
                          }
                        }}
                      >
                        Next
                      </Button>
                    </Box>
                  </Box>
                )}

                {currentTab === 2 && (
                  <Box>
                    <Typography
                      variant="h6"
                      fontSize={20}
                      sx={{ fontWeight: "bold" }}
                      marginBottom={2}
                    >
                      Professional Summary
                    </Typography>

                    <Box
                      display="grid"
                      gap="15px"
                      gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                    >
                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Previous School Name"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.previousSchoolName}
                        name="previousSchoolName"
                        autoComplete="off"
                        error={
                          !!touched.previousSchoolName &&
                          !!errors.previousSchoolName
                        }
                        helperText={
                          touched.previousSchoolName &&
                          errors.previousSchoolName
                        }
                      />

                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Previous Experience"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.previousExperience}
                        name="previousExperience"
                        autoComplete="off"
                        error={
                          !!touched.previousExperience &&
                          !!errors.previousExperience
                        }
                        helperText={
                          touched.previousExperience &&
                          errors.previousExperience
                        }
                      />
                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Current Department*"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.department}
                        name="department"
                        autoComplete="off"
                        error={!!touched.department && !!errors.department}
                        helperText={touched.department && errors.department}
                      />
                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Designation"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.designation}
                        name="designation"
                        autoComplete="off"
                        error={!!touched.designation && !!errors.designation}
                        helperText={touched.designation && errors.designation}
                      />
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Current CTC*"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.currentCtc}
                        name="currentCtc"
                        autoComplete="off"
                        error={!!touched.currentCtc && !!errors.currentCtc}
                        helperText={touched.currentCtc && errors.currentCtc}
                      />

                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Higher Education"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const upperCaseValue = e.target.value.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.higherQualification}
                        name="higherQualification"
                        autoComplete="off"
                        error={
                          !!touched.higherQualification &&
                          !!errors.higherQualification
                        }
                        helperText={
                          touched.higherQualification &&
                          errors.higherQualification
                        }
                      />

                      {/* <StyledTextField
                        fullWidth
                        type="text"
                        label="Reporting Manager"
                        onBlur={handleBlur}
                         onChange={(e) => {
                          const upperCaseValue = e.target.value.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.reportingManager}
                        name="reportingManager"
                        autoComplete="off"
                        error={
                          !!touched.reportingManager &&
                          !!errors.reportingManager
                        }
                        helperText={
                          touched.reportingManager &&
                          errors.reportingManager
                        }
                      />

<StyledTextField
                        fullWidth
                        type="text"
                        label="Reporting Sales Manager"
                        onBlur={handleBlur}
                         onChange={(e) => {
                          const upperCaseValue = e.target.value.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.reportingSalesManager}
                        name="reportingSalesManager"
                        autoComplete="off"
                        error={
                          !!touched.reportingSalesManager &&
                          !!errors.reportingSalesManager
                        }
                        helperText={
                          touched.reportingSalesManager &&
                          errors.reportingSalesManager
                        }
                      /> */}
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      marginTop={3}
                    >
                      <Button
                        variant="contained"
                        style={{ width: "100px", backgroundColor: "#3C3972" }}
                        onClick={() => setCurrentTab(1)}
                      >
                        Previous
                      </Button>
                      <Button
                        variant="contained"
                        style={{ width: "100px", backgroundColor: "#3C3972" }}
                        // onClick={() => {
                        //   validateForm().then((errors) => {
                        //     if (Object.keys(errors).length === 0) {
                        //       setCurrentTab(3);
                        //     }
                        //   });
                        // }}
                        onClick={async () => {
                          // Set all fields as touched to trigger error messages
                          setTouched({
                            currentCtc: true,
                            higherQualification: true,
                            previousSchoolName: true,
                            previousExperience: true,
                            designation: true,
                            department: true,
                          });
                          const errors = await validateForm();
                          if (!Object.keys(errors).length) {
                            setCurrentTab(4);
                          }
                        }}
                      >
                        Next
                      </Button>
                    </Box>
                  </Box>
                )}

                {/* {currentTab === 3 && (
                  <Box>
                    <Typography
                      variant="h6"
                      fontSize={20}
                      sx={{ fontWeight: "bold" }}
                      marginBottom={2}
                    >
                      Salary BreakDown
                    </Typography>

                    <Box
                      display="grid"
                      gap="15px"
                      gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                    >
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Basic Salary"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.basicSalary}
                        name="basicSalary"
                        autoComplete="off"
                        error={!!touched.basicSalary && !!errors.basicSalary}
                        helperText={touched.basicSalary && errors.basicSalary}
                      />
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Tax"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.tax}
                        name="tax"
                        autoComplete="off"
                        error={!!touched.tax && !!errors.tax}
                        helperText={touched.tax && errors.tax}
                      />
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="HRA"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.hra}
                        name="hra"
                        autoComplete="off"
                        error={!!touched.hra && !!errors.hra}
                        helperText={touched.hra && errors.hra}
                      />

                      <StyledTextField
                        fullWidth
                        type="number"
                        label="PF"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.pf}
                        name="pf"
                        autoComplete="off"
                        error={!!touched.pf && !!errors.pf}
                        helperText={touched.pf && errors.pf}
                      />

                      <StyledTextField
                        fullWidth
                        type="number"
                        label="DRA"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.dra}
                        name="dra"
                        autoComplete="off"
                        error={!!touched.dra && !!errors.dra}
                        helperText={touched.dra && errors.dra}
                      />
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Loan Repayment"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.loanRepayment}
                        name="loanRepayment"
                        autoComplete="off"
                        error={
                          !!touched.loanRepayment && !!errors.loanRepayment
                        }
                        helperText={
                          touched.loanRepayment && errors.loanRepayment
                        }
                      />

                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Bonus"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.bonus}
                        name="bonus"
                        autoComplete="off"
                        error={!!touched.bonus && !!errors.bonus}
                        helperText={touched.bonus && errors.bonus}
                      />
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Early Leaving Fine"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.earlyLeavingFine}
                        name="earlyLeavingFine"
                        autoComplete="off"
                        error={
                          !!touched.earlyLeavingFine &&
                          !!errors.earlyLeavingFine
                        }
                        helperText={
                          touched.earlyLeavingFine && errors.earlyLeavingFine
                        }
                      />
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Other Earnings"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.otherEarnings}
                        name="otherEarnings"
                        autoComplete="off"
                        error={
                          !!touched.otherEarnings && !!errors.otherEarnings
                        }
                        helperText={
                          touched.otherEarnings && errors.otherEarnings
                        }
                      />
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Late Coming Fine"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.lateComingFine}
                        name="lateComingFine"
                        autoComplete="off"
                        error={
                          !!touched.lateComingFine && !!errors.lateComingFine
                        }
                        helperText={
                          touched.lateComingFine && errors.lateComingFine
                        }
                      />
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Work Basis Pay"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.workBasisPay}
                        name="workBasisPay"
                        autoComplete="off"
                        error={!!touched.workBasisPay && !!errors.workBasisPay}
                        helperText={touched.workBasisPay && errors.workBasisPay}
                      />
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Other Deductions"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.otherDeductions}
                        name="otherDeductions"
                        autoComplete="off"
                        error={
                          !!touched.otherDeductions && !!errors.otherDeductions
                        }
                        helperText={
                          touched.otherDeductions && errors.otherDeductions
                        }
                      />
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Petrol Allowance"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.petrolAllowance}
                        name="petrolAllowance"
                        autoComplete="off"
                        error={
                          !!touched.petrolAllowance && !!errors.petrolAllowance
                        }
                        helperText={
                          touched.petrolAllowance && errors.petrolAllowance
                        }
                      />
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Food Allowance"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.foodAllowance}
                        name="foodAllowance"
                        autoComplete="off"
                        error={
                          !!touched.foodAllowance && !!errors.foodAllowance
                        }
                        helperText={
                          touched.foodAllowance && errors.foodAllowance
                        }
                      />

                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Over Time"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.overTime}
                        name="overTime"
                        autoComplete="off"
                        error={!!touched.overTime && !!errors.overTime}
                        helperText={touched.overTime && errors.overTime}
                      />
                      <StyledTextField
                        fullWidth
                        type="number"
                        label="Incentive"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        value={values.incentive}
                        name="incentive"
                        autoComplete="off"
                        error={!!touched.incentive && !!errors.incentive}
                        helperText={touched.incentive && errors.incentive}
                      />
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      marginTop={3}
                    >
                      <Button
                        variant="contained"
                        style={{ width: "100px", backgroundColor: "#3C3972" }}
                        onClick={() => setCurrentTab(2)}
                      >
                        Previous
                      </Button>
                      <Button
                        variant="contained"
                        style={{ width: "100px", backgroundColor: "#3C3972" }}
                        onClick={() => {
                          validateForm().then((errors) => {
                            if (Object.keys(errors).length === 0) {
                              setCurrentTab(4);
                            }
                          });
                        }}
                      >
                        Next
                      </Button>
                    </Box>
                  </Box>
                )} */}

                {currentTab === 4 && (
                  <Box>
                    <Typography
                      variant="h6"
                      fontSize={20}
                      sx={{ fontWeight: "bold" }}
                      marginBottom={2}
                    >
                      Bank Details
                    </Typography>
                    {/* <Typography
                      variant="h6"
                      fontSize={16}
                      sx={{ fontWeight: "bold" }}
                      marginBottom={2}
                    >
                      Work Experience :
                    </Typography> */}
                    <Box
                      display="grid"
                      gap="15px"
                      gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                    >
                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Bank Name"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.bankName}
                        name="bankName"
                        autoComplete="off"
                        error={!!touched.bankName && !!errors.bankName}
                        helperText={touched.bankName && errors.bankName}
                      />
                      <StyledTextField
                        fullWidth
                        type="text" // use text instead of number to remove arrows
                        label="Bank Account Number"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          // Allow only digits and limit to 16 (or adjust as needed)
                          const numbersOnly = e.target.value.replace(/[^0-9]/g, '').slice(0, 16);
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: numbersOnly,
                            },
                          });
                        }}
                        value={values.bankAccount}
                        name="bankAccount"
                        autoComplete="off"
                        error={!!touched.bankAccount && !!errors.bankAccount}
                        helperText={touched.bankAccount && errors.bankAccount}
                      />

                      <StyledTextField
                        fullWidth
                        type="text"
                        label="IFSC Code"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const upperCaseValue = e.target.value.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.ifscCode}
                        name="ifscCode"
                        autoComplete="off"
                        error={!!touched.ifscCode && !!errors.ifscCode}
                        helperText={touched.ifscCode && errors.ifscCode}
                      />

                      <StyledTextField
                        fullWidth
                        type="text"
                        label="Bank Branch"
                        onBlur={handleBlur}
                        onChange={(e) => {
                          const lettersOnly = e.target.value.replace(/[^A-Za-z\s]/g, '');
                          const upperCaseValue = lettersOnly.toUpperCase();
                          handleChange({
                            target: {
                              name: e.target.name,
                              value: upperCaseValue,
                            },
                          });
                        }}
                        value={values.bankBranch}
                        name="bankBranch"
                        autoComplete="off"
                        error={!!touched.bankBranch && !!errors.bankBranch}
                        helperText={touched.bankBranch && errors.bankBranch}
                      />
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      marginTop={3}
                    >
                      <Button
                        variant="contained"
                        style={{ width: "100px", backgroundColor: "#3C3972" }}
                        onClick={() => setCurrentTab(2)}
                      >
                        Previous
                      </Button>
                      <Button
                        variant="contained"
                        style={{ width: "100px", backgroundColor: "#3C3972" }}
                        onClick={async () => {
                          // Set all fields as touched to trigger error messages
                          setTouched({
                            bankName: true,
                            bankAccount: true,
                            ifscCode: true,
                            bankBranch: true,
                            // Add other fields similarly
                          });
                          const errors = await validateForm();
                          if (!Object.keys(errors).length) {
                            setCurrentTab(5);
                          }
                        }}
                      >
                        Next
                      </Button>
                    </Box>
                  </Box>
                )}

                {currentTab === 5 && (
                  <Box>
                    <Typography
                      variant="h6"
                      fontSize={20}
                      sx={{ fontWeight: "bold" }}
                      marginBottom={2}
                    >
                      Other Details
                    </Typography>
                    <Box
                      display="grid"
                      gap="30px"
                      gridTemplateColumns="repeat(2, minmax(0, 1fr))"
                    >
                      <StyledTextField
                        fullWidth
                        type="file"
                        InputLabelProps={{ shrink: true }}
                        label="Profile Picture (JPG/JPEG/PNG)"
                        onBlur={handleBlur}
                        onChange={(e) =>
                          setFieldValue("profilePic", e.currentTarget.files[0])
                        }
                        name="profilePic"
                        error={!!touched.profilePic && !!errors.profilePic}
                        helperText={touched.profilePic && errors.profilePic}
                      />
                    </Box>
                    <Box
                      display="flex"
                      justifyContent="space-between"
                      marginTop={3}
                    >
                      <Button
                        variant="contained"
                        style={{
                          width: "100px",
                          height: "35px",
                          backgroundColor: "#3C3972",
                        }}
                        onClick={() => setCurrentTab(4)}
                      >
                        Previous
                      </Button>
                      <StyledButton
                        type="submit"
                        variant="contained"
                        style={{ width: "130px", backgroundColor: "#3C3972" }}
                        disabled={loading}
                        onClick={async (e) => {
                          // e.preventDefault(); // Prevent default form submission
                          // setTouched({
                          //   // profilePic: true,
                          //   // document1: true,
                          //   // Add other fields if needed
                          // });

                          // Trigger form validation
                          const errors = await validateForm();

                          if (Object.keys(errors).length === 0) {
                            // No errors, submit the form
                            handleSubmit(values); // Ensure values are passed
                          }
                        }}
                      >
                        {loading ? (
                          <FacebookCircularProgress
                            size={24}
                            sx={{ color: "#fff" }}
                          />
                        ) : (
                          "Submit The Form"
                        )}
                      </StyledButton>
                    </Box>
                  </Box>
                )}
              </Card>
            </Box>
          </form>
        )}
      </Formik>
      <ToastContainer />
    </Box>
  );
};


export default EmployeeRegForm;